module.exports = __webpack_public_path__ + "img/twitter.62e35603.svg";